import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { MainModule } from '../main/main.module';

import { FeedComponent } from './feed/feed.component';
import { ListComponent } from './list/list.component';
import { IncidentSheetComponent } from './incident-sheet/incident-sheet.component';
import { IncidentFormComponent } from './form/form.component';
import { TranslocoRootModule } from '../transloco/transloco-root.module';


@NgModule({
  declarations: [
  	FeedComponent, 
  	ListComponent, 
  	IncidentFormComponent,
  	IncidentSheetComponent
  ],
  exports: [
  	FeedComponent, 
  	ListComponent, 
  	IncidentFormComponent,
  	IncidentSheetComponent
  ],
  imports: [
    CommonModule, FormsModule,
    CustomMaterialModule, MainModule,
    TranslocoRootModule
  ],
  entryComponents: [
  	IncidentFormComponent
  ]
})
export class IncidentsModule { }
